import { IChoferDisponibleManiobras } from './../models/choferdisponible_maniobras';
import { Component, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import ICredencialUsuario from '../models/credencial';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IResultadoGeneral } from '../models/resultadogeneral';
import { AuthService } from '../services/auth.service';
import { MovFechaService } from '../services/movfecha.service';
import { ConfirmationService, MessageService, MenuItem, ConfirmEventType } from 'primeng/api';
import { ChoferService } from '../services/chofer.service';
import { ItiposValidacion } from '../models/tipos_validacion';
import { saveAs } from 'file-saver';
import { UnidadtransporteService } from '../services/unidadtransporte.service';
import { InumEconomico } from '../models/numEconomico';
import { IRescatePerc } from '../models/RescatePrec';
import { IEnviarExtensionFueraSemana } from '../models/enviar_extensio_fuera_semana';
import { RutaService } from '../services/ruta.service';
import { NonNullAssert } from '@angular/compiler';
import { IServAdiconales } from '../models/ServAdicionales';
import { ExtraService } from '../services/extra.service';
import { ServiciosAdicionalesService } from '../services/serviciosadicionales.service';

@Component({
  selector: 'app-servadiconales',
  templateUrl: './servadiconales.component.html',
  styleUrls: ['./servadiconales.component.scss']
})
export class ServadiconalesComponent {
  @ViewChild('dt1') dt!: Table;
  lstMovimientos: IServAdiconales[] = [];
  selectedMovimiento: IServAdiconales = {} as IServAdiconales;
  // reportes
  // lstMovimientosReporte : IMovimientosFechaExtra[] = [];
  fecha_inicio_r1: any = null;
  fecha_fin_r1: any = null;
  Rutas:any[]=[];
  btngenerandoReporte:boolean=false;
  // fin reportes
  loading: boolean = false;
  fecha_dia: any = null;
  mostrarbtnLimpiarFiltro: boolean = false;
  user: ICredencialUsuario = {};  
  clv_operacion: number = 0;
  //Fecha no se modifica
  fecha_final_dia!: Date;
  fecha_dia_real: any = null;

  data_enviar: any = {};
  habilitar_un_dia: boolean = true;
  dspCalculo:boolean=true;
  //Menu 
  itemsExtra:MenuItem[]=[];
  items: MenuItem[] = [];

  //reportes
  dbsReportes: boolean = false;
  messageFin: string = '';
  texto_nombre_ruta:string='';
  // Variables
  dspViajeVacio: boolean = false;
  kilometros: number = 0;
  calculandoKM: boolean = false;
  btnHabilitarViajeVacio: boolean = false;
  REGEX_COMA: any = /^[^,]*,[^,]*$/;
  
  // FormGroup
  viajeVacioForm: FormGroup = new FormGroup({
    origen:             new FormControl('',[Validators.required, Validators.pattern(this.REGEX_COMA)]),
    destino:            new FormControl('',[Validators.required, Validators.pattern(this.REGEX_COMA)]),
    num_kilometros:     new FormControl({ value: null, disabled: true }),
    costo_por_km:       new FormControl({ value: null, disabled: true }),
    sueldo:             new FormControl({ value: null, disabled: true }),
    viaticos_por_evento:new FormControl({ value: null, disabled: true }),
    fec_pago:           new FormControl(null, Validators.required),
    clv_eliminar:       new FormControl(false)   
  });

  constructor(
    private fb: FormBuilder,
    private RutasService:RutaService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private movfechaService: MovFechaService,
    private auth: AuthService,
    private choferService: ChoferService,
    private servAdicionales: ServiciosAdicionalesService,
    private unidTransporte: UnidadtransporteService) {
    this.cargarInformacionUsuario();

    this.viajeVacioForm.controls['origen'].valueChanges.subscribe(data => {
      if(data==='') this.calculandoKM=false;
    });

    this.viajeVacioForm.controls['destino'].valueChanges.subscribe(data => {
      if(data==='') this.calculandoKM=false;
    });

   
    // this.itemsExtra=[{
    //     label: 'Extensión de Ruta',
    //     icon: 'pi pi-plus',
    //     command: () => {
    //       this.abrirModalViajeVacio();
    //     }
    //   },
    //   {
    //     label: 'Ext de Ruta Fuera de Semana',
        
    //     styleClass:'p-button-warning',
    //     icon: 'pi pi-plus-circle',
    //     command: () => {
    //       this.abrirModalViajeVacio();
    //     }
    //   }
    // ];
    // this.items=[{
    //   label: 'Monitoreo',
    //   styleClass:'p-button-secondary',
    //   tooltip:'En Proceso',
    //   disabled: [3, 5, 6].includes(this.data_enviar.clv_operacion),
    //   icon: 'pi pi-globe',
    //   command: () => {
    //     this.abrirModalViajeVacio();
    //   }
    // },
    // {
    //   label: 'Maniobras',
    //   styleClass:'p-button-secondary',
    //   icon: 'pi pi-users',
    //   command: () => {
    //     this.abrirModalViajeVacio();
    //   }
    // },
    // {
    //   label: 'Tienda Adicional',
    //   styleClass:'p-button-secondary',
    //   icon: 'pi pi-shopping-cart',
    //   command: () => {
    //     this.abrirModalViajeVacio();
    //   }
    // },
    // {
    //   label: 'Rescate de Unidad',
    //   styleClass:'p-button-secondary',
    //   icon: 'pi pi-truck',
    //   command: () => {
    //     this.abrirModalViajeVacio();
    //   }
    // },
    // {
    //   label: 'Eventualidad',
    //   styleClass:'p-button-secondary',
    //   disabled: this.data_enviar['clv_configuracion']!==1,
    //   icon: 'pi pi-shield',
    //   command: () => {
    //     this.abrirModalViajeVacio();
    //   }
    // }];
  }

  resetDataEnviar(){
    this.data_enviar = {
      idx: 0,
      idx_pao_diario_unidades: 0,
      id_ruta: 0,
      desc_ruta: '',
      clv_especial: 0,
      desc_tiporuta: '',
      desc_cliente: '',
      id_cliente: 0,
      desc_proyecto: '',
      id_proyecto: 0,
      desc_ciudad: '',
      id_ciudad: 0,
      num_economico: '',
      id_unidad_transporte: 0,
      datos_generales: '',
      cod_chofer: 0,
      nombre_chofer: '',
      fecha: '',
      clv_operacion: 0,
      clv_foranea: 0,
      clv_fin_ruta: 0,
      clv_cancelado: 0,
      cod_adicional1: 0,
      cod_adicional2: 0,
      id_puesto: 0,
      id_puesto1: 0,
      id_puesto2: 0,
      nombre_completo_adicional1: '',
      nombre_completo_adicional2: '',
      desc_puesto_principal: '',
      desc_puesto_adicional1: '',
      desc_puesto_adicional2: '',
      jsonManiobras: [],
      hora: '',
      num_tiendas_adicionales: 0,
      imp_tienda_adicional: 0,
      imp_tienda_adicional_total: 0,
      num_dias_extra: 0,
      num_dias_extra_fuera_semana: 0,
      num_terceros: 0,
      imp_terceros: 0,
      imp_tab_total_extra_driver: 0,
      imp_tab_total_extra_auxiliar: 0,
      imp_viaticos_extra_driver: 0,
      imp_viaticos_extra_auxiliar: 0,
      imp_viaticos_extra_hospedaje: 0,
      imp_tab_total_extra_driver_fuera_semana: 0,
      imp_tab_total_extra_auxiliar_fuera_semana: 0,
      imp_viaticos_extra_driver_fuera_semana: 0,
      imp_viaticos_extra_auxiliar_fuera_semana: 0,
      imp_viaticos_extra_hospedaje_fuera_semana: 0,
      num_economico_rescate: '',
      num_folio: '',
      desc_folio: '',
      num_dias_estadia: 0,
      num_dias_estadia_fuera_semana: 0,
      fec_salida: '',
      hora_salida: '',
      fec_llegada: '',
      hora_llegada: '',
      chk_cumple: 0,
      num_domicilios_visitados: 0,
      num_paquetes_entregados: 0,
      clv_fin_gestion: 0,
      clv_llegada: 0,
      clv_salida: 0,
      num_servicios_prestados:0,
      clv_cumple_llegada:0,
      clv_cumple_salida:0,
      num_domicilios_programados:0,
      num_paquetes_programados:0,
      desc_cumple_paquetes:'',
      desc_cumple_domicilios:'',
      desc_fin_gestion:'',
      desc_cumple_salida:'',
      desc_cumple_llegada:'',
      // id_rescate_porc:0,
      // num_rescate_porc:0,
      clv_extension:0,
      clv_extension_fuera:0,
      fec_fuera_semana:'',
      imp_driver_ruta:0,
      imp_auxiliar_ruta:0,
      imp_viaticos_rescate:0,
      clave_configuracionUnidad:0,
    imp_sueldo_driver:0,
    imp_sueldo_auxiliar:0,
    id_eventualidad:0,
    desc_evento:'',
    desc_complemento:'',
    clv_eventualidad:0,
    clv_configuracion:0,
    id_evento:0
    };
  }
  // actualizarItemsExtra(data: any) {
  //   this.itemsExtra = [
  //     {
  //       label: 'Extensión de Ruta',
  //       icon: 'pi pi-plus',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     },
  //     {
  //       label: 'Ext de Ruta Fuera de Semana',
  //       styleClass: 'p-button-warning',
  //       icon: 'pi pi-plus-circle',
  //       //disabled: ![1, 2, 3].includes(data?.clave_configuracionUnidad ?? -1), // Condición dinámica
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     }
  //   ];
  // }
  // actualizarItems(data: any) {
  //   this.items = [
  //     {
  //       label: 'Monitoreo',
  //       styleClass: 'p-button-secondary',
  //       tooltip: 'En Proceso',
  //       icon: 'pi pi-globe',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     },
  //     {
  //       label: 'Maniobras',
  //       styleClass: 'p-button-secondary',
  //       icon: 'pi pi-users',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     },
  //     {
  //       label: 'Tienda Adicional',
  //       styleClass: 'p-button-secondary',
  //       icon: 'pi pi-shopping-cart',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     },
  //     {
  //       label: 'Rescate de Unidad',
  //       styleClass: 'p-button-secondary',
  //       icon: 'pi pi-truck',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     },
  //     {
  //       label: 'Eventualidad',
  //       styleClass: 'p-button-secondary',
  //       disabled: ![5, 7].includes(data?.clave_configuracionUnidad ?? -1), // Condición dinámica
  //       icon: 'pi pi-shield',
  //       command: () => {
  //         this.abrirModalViajeVacio();
  //       }
  //     }
  //   ];
  // }
  cargarFechasYHoraFormulario(num_opcion: number) {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    var hourDate = new Date().toLocaleString('es-MX', { hour: 'numeric', minute: 'numeric', second: 'numeric',hour12: false });
  }
  
  ngOnInit(): void {
    this.inicializarFechasFormateadas();
  }
  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }
  // SeleccionExtension(data:any){
  //   this.data_enviar=data;
  //   this.actualizarItems(data);
  //   this.actualizarItemsExtra(this.data_enviar);
  // }

  save(data: any) {
    this.data_enviar = data;
  }

  inicializarFechasFormateadas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.fecha_dia = dateFormat;
    //Fecha que no se modifica
    this.fecha_final_dia = new Date(dateFormat + 'T00:00:00');
    //Fecha del dia real, no se mueve
    this.fecha_dia_real = dateFormat;
  }

  
  
  

  cargarInformacionPorFecha(fecha: string, fecha_fin: string) {
    let fecha_fin_cast = fecha_fin == null ? '1900-01-01' : fecha_fin;
    this.lstMovimientos = [];
    this.loading = true;
    if (fecha == null) {
      this.mostrarDialogoInformativo('<b>Aviso</b> Es necesario seleccionar <b>Fecha</b> de Operación a Filtrar');
    } else {
      this.servAdicionales.getListadoDeMovimientosFecha(fecha,'1900-01-01',this.user.cod).subscribe((resp) => {
        this.lstMovimientos = resp;
        
        if (!this.lstMovimientos.length || typeof this.lstMovimientos === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion con la Fecha Seleccionada de Operaciones');
        }
        this.mostrarbtnLimpiarFiltro = true;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Informacion de Operacion Diaria');
      });
    }
  }

  // cargarInformacionPorFechaReporte(fecha: string, fecha_fin: string) {
  //   this.btngenerandoReporte=true;
  //   let fecha_fin_cast = fecha_fin == null ? '1900-01-01' : fecha_fin;
  //   this.lstMovimientosReporte = [];
  //   if (fecha == null) {
  //     this.mostrarDialogoInformativo('<b>Aviso</b> Es necesario seleccionar <b>Fecha</b> de Operación a Filtrar');
  //   } else {
  //     this.extraService.getListadoDeMovimientosFecha(fecha,fecha_fin,this.user.cod).subscribe((resp) => {
  //       this.lstMovimientosReporte = resp;
  //       if (!this.lstMovimientosReporte.length || typeof this.lstMovimientosReporte === 'undefined') {
  //         this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion con la Fecha Seleccionada para el Reporte');
  //         this.btngenerandoReporte=false;
  //       } else {
  //         this.exportarExcelMovimientos();
  //         this.btngenerandoReporte=false;
  //       }
  //     },
  //       (error) => {
  //         this.btngenerandoReporte=false;
  //         this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Informacion de Operacion Diaria');
  //       });
  //   }
  // }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
  }
  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }

  calcularKM(){
    let data = this.viajeVacioForm.value;
    this.calculandoKM=true;
    this.servAdicionales.getKilometros(data.origen!, data.destino!).subscribe((resp)=>{
      console.log(resp);
      if(resp['status']==false){
        this.messageService.add({ severity: 'error', summary: 'Favor de revisar Origen/Destino', detail: 'El origen o destino no son válidos.' });
        this.calculandoKM=false;
        return;
      }
      else if(resp['status']==true){
        console.log(resp['km'])
        this.viajeVacioForm.controls['num_kilometros'].setValue(resp['km']);
          this.ObtenerCalcViajeVacio(resp['km']);
        setTimeout(() => {
          
          this.calculandoKM=false;
        }, 200);
      }
    })
  }

   ObtenerCalcViajeVacio(nm_km:number){
    this.servAdicionales.getCalculoSueldo(nm_km).subscribe((resp)=>{
      console.log(resp);
      if(resp==='undefined'){
        this.messageService.add({ severity: 'error', summary: 'Error al calcular sueldo', detail: 'Favor de revisar los datos ingresados.' });
        return;
      }
      else{
        setTimeout(() => {
          this.viajeVacioForm.controls['costo_por_km'].setValue(resp['imp_kim']);
          this.viajeVacioForm.controls['sueldo'].setValue(resp['imp_evento']);
          this.viajeVacioForm.controls['viaticos_por_evento'].setValue(resp['imp_viatico_evento']);
        }, 200);
      }
    })
  }

  // guardarInformacionExtensionFSemana() {
  //   let data_enviar: IEnviarExtensionFueraSemana = {
  //     id_pao_diario_unidades: this.extensionFSemanaForm.get('id_pao_diario_unidades')?.value,
  //     imp_tab_total_extra_driver_fuera_semana: this.extensionFSemanaForm.get('imp_tab_total_extra_driver_fuera_semana')?.value,
  //     imp_tab_total_extra_auxiliar_fuera_semana: this.extensionFSemanaForm.get('imp_tab_total_extra_auxiliar_fuera_semana')?.value,
  //     imp_viaticos_extra_driver_fuera_semana: this.extensionFSemanaForm.get('imp_viaticos_extra_driver_fuera_semana')?.value,
  //     imp_viaticos_extra_auxiliar_fuera_semana: this.extensionFSemanaForm.get('imp_viaticos_extra_auxiliar_fuera_semana')?.value,
  //     imp_viaticos_extra_hospedaje_fuera_semana: this.extensionFSemanaForm.get('imp_viaticos_extra_hospedaje_fuera_semana')?.value,
  //     fec_fuera_semana: this.extensionFSemanaForm.get('fec_fuera_semana')?.value,
  //     num_dias_extra_fuera_semana: this.calculoFueraSemanaForm.get('num_dias_extra_fuera_semana')?.value,
  //     num_dias_estadia_fuera_semana: this.calculoFueraSemanaForm.get('num_dias_estadia_fuera_semana')?.value,
  //     cod_usuario: this.user.cod!
  //   }
  //   this.extraService.agregarExtensionFueraSemana(data_enviar).subscribe((resp) => {
  //     if(resp.clv_estatus == -2)
  //       this.messageService.add({ severity: 'warn', summary: 'Atención', detail: resp.messageDetails });
  //     else{
  //       this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: resp.messageDetails });
  //       this.btnHabilitarExtensionFueraSemana = true;
  //       this.btnGuardarExtensionFueraSemana = false;
  //       this.cargarInformacionPorFecha(this.fecha_dia, this.user.cod!);
  //       this.cancelarModalExtensionFueraSemana();
  //     }      
  //   },
  //     (error) => {
  //       this.btnHabilitarExtensionFueraSemana = false;
  //       this.messageService.add({ severity: 'error', summary: 'Error en <Guardar Extension de Ruta Fuera de Semana>', detail: 'Contacte al Administrador del Sitio' });
  //     });
  // }

  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  LimpiarFiltro() {
    this.lstMovimientos = [];
    this.fecha_dia = null;
    this.limpiarFiltrosTabla();
    this.mostrarbtnLimpiarFiltro = false;
  }

  limpiarFiltrosTabla() {
    this.dt.clear();
  }

  // public eliminarObjetoArray(arr: any, item: any) {
  //   var i = arr.indexOf(item);
  //   if (i !== -1) {
  //     // eliminar en informacion de ruta bd. 
  //     if (item.clv_guardado == 0) {
  //       //si existia en base de datos se manda a eliminar
  //       this.lstchofer.push({
  //         cod_chofer: item.cod_chofer,
  //         clv_guardado: 3,
  //         imp_maniobras: 0
  //       });
  //     }
  //     arr.splice(i, 1);
  //   }
  // }

  // public deshabilitarObjetoArray(arr: IChoferDisponibleManiobras[], item: IChoferDisponibleManiobras) {
  //   var i = arr.indexOf(item);
  //   if (i !== -1) {
  //     arr[i].disabled = 1;
  //   }
  // }

  calcularExtension() {
    // if (this.btnHabilitarExtension == false) {
    //   let id_ruta = this.calculoForm.get('id_ruta')?.value;
    //   let extra = this.calculoForm.get('num_dias_extra')?.value;
    //   let estad = this.calculoForm.get('num_dias_estadia')?.value; 
    //   this.extensionForm.controls['num_dias_extra'].setValue(extra);
    //   this.extensionForm.controls['num_dias_estadia']?.setValue(estad);

    //   this.extraService.getcalculoRuta(id_ruta, extra, estad,this.data_enviar.fecha).subscribe((resp) => {
    //     let data: ICalculoExtension = resp;
    //     this.extensionForm.controls['imp_tab_total_extra_driver'].setValue(data.imp_tab_total_extra_driver);
    //     this.extensionForm.controls['imp_tab_total_extra_auxiliar'].setValue(data.imp_tab_total_extra_auxiliar);
    //     this.extensionForm.controls['imp_viaticos_extra_driver'].setValue(data.imp_viaticos_driver);
    //     this.extensionForm.controls['imp_viaticos_extra_auxiliar'].setValue(data.imp_viaticos_auxiliar);
    //     this.extensionForm.controls['imp_viaticos_extra_hospedaje'].setValue(data.imp_viaticos_hospedaje);
    //     this.btnGuardarExtension = true;
    //   },
    //   (error) => {
    //     this.btnHabilitarExtension = true;
    //     this.btnGuardarExtension = false;
    //     this.messageService.add({ severity: 'error', summary: 'Error en <Calcular Extesion de Ruta>', detail: 'Contacte al Administrador del Sitio' });
    //   });
    // } else {
    //   this.mostrarDialogoInformativo('No esta disponible el calculo por la Fecha y/o permiso de Habilitar Edición');
    // }
  }
  
  abrirModalReportes() {
    this.dbsReportes = true;
    this.btngenerandoReporte=false;
    let fecha = this.obtenerFechaMomento();
    //asignar fechas de reportes
    this.fecha_inicio_r1=fecha;
    this.fecha_fin_r1=fecha;
  }

  cancelarModalReportes() {
    this.dbsReportes = false;
    this.btngenerandoReporte=false;
    //reiniciar todas las variables

  }

  obtenerFechaMomento():string{
    let fecha:any;
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    fecha = getYear + "-" + getMonth + "-" + getDay;
    return fecha;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName /*+ "_export_" + dateFormat */ + EXCEL_EXTENSION);

  }

  // badges(data: IMovimientosFechaExtra):string{
  //   let bdg=0;
  //   if(data.clv_extension==1) bdg++;
  //   if(data.fec_fuera_semana!='1900-01-01'||data.fec_fuera_semana != null) bdg++;

  //   return String(bdg);
  // }

  eraseViajeVacio(){
    this.confirmaEraseViajeVacio();
  }

  confirmaEraseViajeVacio(){
    this.confirmationService.confirm({
      message: 'Esta seguro que desea <b>Eliminar</b> Viaje Vacío, correspondiente a <b>'+this.selectedMovimiento.desc_folio+'</b>?',
      header: 'Confirmacion de Eliminacion',
      icon: 'pi pi-info-circle',
      accept: () => {
        setTimeout(() => {
            this.eliminaViajeVacio();
          }, 150);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Rechazado', detail: 'Se ha Rechazado la operación' });
            break;
          case ConfirmEventType.CANCEL:          
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Se ha Cancelado la operación' });
            break;
        }
      }
      ,key: "kc"
    });
  }

  eliminaViajeVacio(){
    let data_enviar=
    {
      id: this.selectedMovimiento.idx, 
      cod_usuario: this.user.cod!
    };
    console.log(data_enviar);
    this.servAdicionales.deleteViajeVacio(data_enviar).subscribe((resp) => {
          if(resp.clv_estatus == -2)
            this.messageService.add({ severity: 'warn', summary: 'Atención', detail: resp.messageDetails });
          else{
            this.cancelarModalViajeVacio();
            this.cargarInformacionPorFecha(this.fecha_dia,'1900-01-01');
            this.messageService.add({ severity: 'success', summary: 'Proceso realizado con exito', detail: resp.messageDetails });        
          }
    },
    (error) => {
      this.messageService.add({ severity: 'error', summary: 'Error en <Eliminar Viaje Vacio>', detail: 'Contacte al Administrador del Sitio' });
    });
  }

  abrirModalViajeVacio(data: IServAdiconales){ 
    this.dspViajeVacio = true;
    this.selectedMovimiento = data;

    if(this.selectedMovimiento.idx!=0){
      this.viajeVacioForm.patchValue({
        origen: this.selectedMovimiento.desc_origen,
        destino: this.selectedMovimiento.desc_destino,
        num_kilometros: this.selectedMovimiento.num_kilometros,
        costo_por_km: this.selectedMovimiento.imp_costo_km,
        sueldo: this.selectedMovimiento.imp_sueldo_base_evento,
        viaticos_por_evento: this.selectedMovimiento.imp_viaticos_evento,
        fec_pago: this.selectedMovimiento.fec_pago,
        clv_eliminrar: this.selectedMovimiento.clv_eliminar==1?true:false
      });

      this.disableViajeVacioForm();
      this.calculandoKM=true;
      this.btnHabilitarViajeVacio=true;
    }
  }
  enableViajeVacioForm(){
    this.viajeVacioForm.controls['origen'].enable();
    this.viajeVacioForm.controls['destino'].enable();
    this.viajeVacioForm.controls['num_kilometros'].enable();
    this.viajeVacioForm.controls['costo_por_km'].enable();
    this.viajeVacioForm.controls['sueldo'].enable();
    this.viajeVacioForm.controls['viaticos_por_evento'].enable();
    this.viajeVacioForm.controls['fec_pago'].enable();
  }
  disableViajeVacioForm(){
    this.viajeVacioForm.controls['origen'].disable();
    this.viajeVacioForm.controls['destino'].disable();
    this.viajeVacioForm.controls['num_kilometros'].disable();
    this.viajeVacioForm.controls['costo_por_km'].disable();
    this.viajeVacioForm.controls['sueldo'].disable();
    this.viajeVacioForm.controls['viaticos_por_evento'].disable();
    this.viajeVacioForm.controls['fec_pago'].disable();
  }
  cancelarModalViajeVacio(){
    this.dspViajeVacio = false; 
    this.btnHabilitarViajeVacio = false;
    this.calculandoKM = false;
    this.enableViajeVacioForm();
    //  this.kilometros = 0; 
    this.viajeVacioForm.reset(); 
    this.selectedMovimiento = {} as IServAdiconales;;
  }
  
  guardarViajeVacio(){
    let data = this.viajeVacioForm.getRawValue();
    console.log(this.viajeVacioForm);
    console.log(data);
    let data_enviar: any = {
      idx_pao_diario_unidades: this.selectedMovimiento.idx_pao_diario_unidades
      ,fecha: this.selectedMovimiento.fecha
      ,id_ciudad_hm: this.selectedMovimiento.id_ciudad
      ,desc_origen: data.origen!
      ,desc_destino: data.destino!
      ,num_kilometros: data.num_kilometros!
      ,imp_costo_km: data.costo_por_km!
      ,imp_sueldo_base_evento: data.sueldo!
      ,imp_viaticos_evento: data.viaticos_por_evento!
      ,imp_total: data.sueldo!+data.viaticos_por_evento!+data.costo_por_km!
      ,fec_pago: data.fec_pago!
      ,cod_usuario: this.user.cod!
    }
    console.log(data_enviar);
    this.servAdicionales.saveViajeVacio(data_enviar).subscribe((resp) => {
      if(resp.clv_estatus == -2)
        this.messageService.add({ severity: 'warn', summary: 'Atención', detail: resp.messageDetails });
      else{
        this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: resp.messageDetails });
        this.btnHabilitarViajeVacio = true;
        this.cargarInformacionPorFecha(this.fecha_dia, this.user.cod!);
        this.cancelarModalViajeVacio();
      }
    });
  }
}
